import { ApplicationConfig, LOCALE_ID, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { routes } from './app.routes';
import { provideClientHydration } from '@angular/platform-browser';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { AuthInterceptor } from './common/interceptors/auth.interceptor';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE, MatDateFormats } from '@angular/material/core';
import { MomentDateAdapter, provideMomentDateAdapter } from '@angular/material-moment-adapter'
import { GlobalErrorInterceptor } from './common/interceptors/error.interceptor';
import { LoadingInterceptor } from './common/interceptors/loading.interceptor';

export const HR_DATE_FORMATS: MatDateFormats = {
  parse: {
    dateInput: 'D.M.YYYY.',
    timeInput: 'HH:mm',
  },
  display: {
    dateInput:          'D.M.YYYY.',
    monthYearLabel:     'MMM YYYY',
    dateA11yLabel:      'D. MMMM YYYY',
    monthYearA11yLabel: 'MMMM YYYY',
    timeInput:       'H:mm',
    timeOptionLabel: 'H:mm',
  }
};


export const appConfig: ApplicationConfig = {
    providers: [
         provideZoneChangeDetection({ eventCoalescing: true }),
         provideRouter(routes), 
         provideClientHydration(), 
         provideMomentDateAdapter(),
         provideAnimationsAsync(), 
         provideHttpClient(withInterceptorsFromDi()),
         {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthInterceptor,
            multi: true
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: LoadingInterceptor,
            multi: true
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: GlobalErrorInterceptor,
            multi: true
        },
         // DateAdapter configuration
         { provide: DateAdapter, useClass: MomentDateAdapter },
         { provide: MAT_DATE_FORMATS, useValue: HR_DATE_FORMATS },
         { provide: MAT_DATE_LOCALE, useValue: 'hr' },
         { provide: LOCALE_ID, useValue: 'hr' }
    
    ]
};